import { ConfigProvider as ConfigProviderAntd } from 'antd';
import type { ConfigProviderProps } from 'antd/lib/config-provider';

const ConfigProvider = (props: ConfigProviderProps) => <ConfigProviderAntd {...props} />;

export type { ConfigProviderProps };
export default ConfigProvider;
